// language.service.ts
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly storageKey = 'language';

  constructor(private translate: TranslateService) {}

  initializeLanguage(): void {
    // Get language from session storage or use default
    const savedLanguage = sessionStorage.getItem('language');
    const browserLang = this.translate.getBrowserLang();
    const defaultLanguage = this.translate.defaultLang || 'en';
    
    const languageToUse = savedLanguage || browserLang || defaultLanguage;
    this.translate.use(languageToUse);
    
    this.setLanguage(languageToUse);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    sessionStorage.setItem(this.storageKey, lang);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }
}